// File types browsers render inline in a tab. Everything else (xlsx, docx,
// csv, zip, ...) triggers a download, so opening it in a blank tab strands the
// user on about:blank — those must be downloaded instead.
const PREVIEWABLE_EXTENSIONS = new Set([
  "pdf",
  "png",
  "jpg",
  "jpeg",
  "gif",
  "webp",
  "svg",
  "bmp",
  "avif",
]);

/**
 * Decides whether a file can be previewed in a browser tab. Accepts either a
 * bare extension (`"pdf"`) or a filename / URL (`"report.xlsx"`,
 * `".../a.pdf?token=x"`).
 */
const isPreviewableFile = (fileNameOrExtension?: string | null): boolean => {
  if (!fileNameOrExtension) return false;
  // Drop any query string / hash before reading the extension.
  const clean = fileNameOrExtension.split(/[?#]/)[0];
  const ext = clean.includes(".") ? clean.split(".").pop() : clean;
  return !!ext && PREVIEWABLE_EXTENSIONS.has(ext.toLowerCase());
};

export default isPreviewableFile;
